import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography } from "@mui/material";
import { useAppThemeContext } from "../../contexts";

interface IDialogConfirmrProps {
    /**
     * Titilo do modal de confirmação
     */
    titulo?: string;

    /** 
     * Texto do corpo do modal 
     */
    texto?: string;

    /**
     *  Bolean que indica se o model deve ser aberto ou fechado
     */
    abrir?: boolean;

    /**
     * Função ao confirmar
     */
    AoConfirmar?: () => void;

    /**
     * Função ao cancelar
     */
    AoCancelar?: () => void;
}

export const DialogConfirm: React.FC<IDialogConfirmrProps> = ({
    titulo = 'confirmar',
    texto = 'teste',
    abrir = false,
    AoConfirmar,
    AoCancelar
}) => {
    const { themeName } = useAppThemeContext();

    return (
        <Dialog
            open={abrir}
            onClose={AoCancelar}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {titulo}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {texto}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={AoCancelar} autoFocus>
                    <Typography
                        variant="button"
                        color={themeName === 'dark' ? 'primary' : 'secondary'}
                    >
                        Cancelar
                    </Typography>
                </Button>
                <Button onClick={AoConfirmar}>
                    <Typography
                        variant="button"
                        color={themeName === 'dark' ? 'primary' : 'secondary'}
                    >
                        Confirmar
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    )

}
